import React from 'react';

import BaseClass from '@/pages/BaseClass';
import areaList from '@/utils/area';

import {CommonValue, httpPost, message, pcUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            payInfo: {
                classInfo: {
                    subjectExp: ""
                }
            },
            pay: false,
            payType: 10, // 10：微信，20：支付宝
            qrCodeRequest: "",
            payButton: false,
            showAddress: false,
            addressInfo: {},
            passwordInfo: {},
            provinceList: [],
            cityList: [],
            areaList: [],
            formValid: {
                address: false
            },

            interval: function () {
            }
        };
    }

    componentDidMount() {
        let payInfo = CommonValue.get('pay_info');
        if (!payInfo) {
            this.props.history.goBack();
        }

        this.getClassInfo(payInfo.courseId);
    }

    getClassInfo(courseId) {
        let url = pcUrl('/course/' + courseId);
        httpPost(url, {}, 'get').then(classInfo => {
            this.state.payInfo = CommonValue.get('pay_info');
            this.state.payInfo.classInfo = classInfo;

            if (classInfo.type === '01') {
                this.getCategoryList('');
            } else if (classInfo.type === '02') {
                this.getCategoryList('technology');
            }
        });
    }

    getCategoryList(type) {
        let url = pcUrl('/course/subject?type=' + type);
        httpPost(url, {}, 'get').then(data => {
            let subjectExp;
            if (type == 'technology') {
                subjectExp = this.state.payInfo.classInfo['subject'].split(',').map(key => {
                    let find = data.find(row1 => row1.v == key);
                    return find ? find.n : '';
                }).join('，') || '无';
            } else {
                subjectExp = this.state.payInfo.classInfo['subject'].split(',').map(key => {
                    let find;
                    data.some(row => {
                        find = row.s.find(row1 => row1.v == key);
                        if (find)
                            return true;
                    });
                    return find ? find.n : '';
                }).join('，') || '无'
            }
            this.state.payInfo.classInfo.subjectExp = subjectExp;
            this.setState({}); // 加载最后一起触发
        });
    }

    payType(payType) {
        this.setState({
            payType: payType
        });
    }

    pay() {
        if (!this.state.payButton) {
            alert("请阅读并勾选《用户协议》及《隐私政策》")
            return;
        }

        let url = pcUrl('/order/' + this.state.payInfo.id);
        const interval = setInterval(() => {
            httpPost(url, {}, 'get')
                .then(data => {
                    console.log(data);
                    if (data.orderStatus == "1") {
                        this.payed();
                    }
                });
        }, 3000);

        this.setState({
            pay: true,
            qrCodeRequest: {
                orderId: this.state.payInfo.id,
                payType: this.state.payType
            },
            interval: interval
        });

    }

    cancel() {
        this.setState({
            pay: false,
            qrCodeRequest: ''
        });
        clearInterval(this.state.interval);
    }

    payed() {
        clearInterval(this.state.interval);

        if (this.state.payInfo.classInfo.type == '02') {
            this.cancel();
            this.setState({
                showAddress: true
            });
            this.showAddressModel();
        } else {
            this.setState({
                showAddress: false
            });
            this.props.history.push('/user/index');
        }
    }

    readDoc() {
        this.setState({
            payButton: !this.state.payButton
        });
    }

    showAddressModel() {
        this.setState({
            showAddress: true
        });

        let url = pcUrl('/personal/address');
        httpPost(url, {}, 'GET').then(data => {
            if (data && data.id) {
                let provinceList = this.getAreaList();
                let addressInfo = data;

                this.setState({
                    provinceList,
                    addressInfo,
                }, () => {
                    this.checkFormValid('address');
                });
                this.provinceChange(addressInfo.province);
            } else {
                let addressInfo = this.state.addressInfo;
                let provinceList = this.getAreaList();
                addressInfo.province = Object.keys(provinceList)[0];
                this.setState({
                    provinceList,
                    addressInfo,
                });
                this.provinceChange(addressInfo.province);
            }
        });
    }

    getAreaList(parentCode) {
        if (!parentCode)
            parentCode = 100000;

        return areaList[parentCode] || [];
    }

    provinceChange(province) {
        let cityList = this.getAreaList(province);
        let addressInfo = this.state.addressInfo;
        addressInfo.province = province;
        addressInfo.city = Object.keys(cityList)[0];

        this.setState({
            'cityList': cityList,
            'addressInfo': addressInfo,
        });

        this.cityChange(addressInfo.city);
    }

    cityChange(city) {
        let areaList = this.getAreaList(city);
        let addressInfo = this.state.addressInfo;
        addressInfo.city = city;
        addressInfo.area = Object.keys(areaList)[0];

        this.setState({
            'areaList': areaList,
            'addressInfo': addressInfo,
        });
        this.areaChange(addressInfo.area);
    }

    areaChange(area) {
        let addressInfo = this.state.addressInfo;
        addressInfo.area = area;

        this.setState({
            'addressInfo': addressInfo,
        });
    }

    cancelAddress() {
        this.setState({
            showAddress: false
        });
    }

    validateAddress(param) {
        let result = {
            'flag': false,
            'message': '',
            'ref': '',
        };
        if (!param.name) {
            result.message = '请输入收件人';
            result.ref = 'addressNameRef';
            return result;
        }
        if (!param.mobile) {
            result.message = '请输入收件人电话';
            result.ref = 'addressMobileRef';
            return result;
        }
        let preg = /^1\d\d\d{8}$/;
        if (!param.mobile.match(preg)) {
            result.message = '请填写正确的手机号';
            result.ref = 'addressMobileRef';
            return result;
        }
        if (!param.postCode) {
            result.message = '请填写邮政编码';
            result.ref = 'addressPostCodeRef';
            return result;
        }
        if (param.postCode.length > 6) {
            result.message = '请填写6位数的邮政编码';
            result.ref = 'addressPostCodeRef';
            return result;
        }
        if (!param.province) {
            result.message = '请选择所在省份';
            result.ref = 'addressPostCodeRef';
            return result;
        }
        if (!param.city) {
            result.message = '请选择所在城市';
            result.ref = 'addressCityRef';
            return result;
        }
        if (!param.area) {
            result.message = '请选择所在地区';
            result.ref = 'addressAreaRef';
            return result;
        }
        if (!param.address) {
            result.message = '请填写详细地址';
            result.ref = 'addressRef';
            return result;
        }
        result['flag'] = true;
        return result;
    }

    checkFormValid(key) {
        let result = this.validateAddress(this.state.addressInfo);
        let formValid = this.state.formValid;
        formValid[key] = result['flag'];
        this.setState({formValid});
    }

    submitAddress() {
        let url = pcUrl('/personal/address');
        let param = this.state.addressInfo;
        let result = this.validateAddress(param);
        if (!result.flag) {
            message(result.message);
            this[result.ref].focus();
            return false;
        }

        httpPost(url, param, 'PUT')
            .then(() => {
                message('地址保存成功', 'success');
                this.props.history.push('/user/index');
            });
    }

    render() {
        return (
            <>
                <div className="height-20"></div>
                <div className="body">
                    <div className="pay-panel table-panel">
                        <div className="captain">
                            <h3> 选中课题 </h3>
                        </div>
                        <div className="panel-body">
                            <table className="pay-table">
                                <tr>
                                    <th width="200">课题</th>
                                    <th width="200">名称</th>
                                    <th>详情</th>
                                    <th>价格</th>
                                </tr>
                                <tr>
                                    <td>
                                        <a href="javascript:;">
                                            <img className="thumb"
                                                 src={this.state.payInfo.classInfo.thumbUrl || require("@/assets/images/class_thumb.jpg")}/>
                                        </a>
                                    </td>
                                    <td>
                                        <a href="javascript:;">
                                            {this.state.payInfo.classInfo.name}
                                        </a>
                                    </td>
                                    <td>
                                        <div className="row">
                                            <div className="col-6">
                                                导师姓名：
                                                {this.state.payInfo.classInfo.teacherName}
                                            </div>
                                            <div className="col-6">
                                                导师学校：
                                                {this.state.payInfo.classInfo.teacherSchool}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                关联专业：
                                                {this.state.payInfo.classInfo.subjectExp}
                                            </div>
                                            <div className="col-6">
                                                关键词：
                                                {this.state.payInfo.classInfo.keywords}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
										<span className="price text-red">
											￥{this.state.payInfo.disPrice}
										</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div className="height-20"></div>
                    <div className="pay-panel">
                        <div className="captain">
                            <h3>支付方式</h3>
                        </div>
                        <div className="panel-body">
                            <div className="pay-method">
                                <ul>
                                    <li>
                                        <a href="javascript:;" onClick={() => this.payType(10)}
                                           className={this.state.payType == 10 ? 'now' : ''}>
                                            <span className="clips wechat-pay-ico"></span>
                                            &nbsp;
                                            微信支付
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:;" onClick={() => this.payType(20)}
                                           className={this.state.payType == 20 ? 'now' : ''}>
                                            <span className="clips alipay-ico"></span>
                                            &nbsp;
                                            支付宝
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="pay-foot">
                                <div className="float-left">
                                    支付金额：
                                    <span className="total-price text-red">
										￥{this.state.payInfo.disPrice}
									</span>
                                </div>
                                <div>
                                    <p>
                                        <button className="button button-blue" onClick={() => this.pay()}>确认购买</button>
                                        {/*<button className="button button-blue" onClick={() => this.showAddressModel()}>填写地址</button>*/}
                                    </p>
                                    <div>
                                        <label>
                                            <input id="readBox" type="checkbox" onChange={() => this.readDoc()}/>
                                            我已阅读并接受
                                            <a href="file/UserAgreement.html" target="_blank">《用户协议》</a>
                                            和
                                            <a href="file/PrivacyPolicy.html" target="_blank">《隐私政策》</a>
                                        </label>
                                    </div>
                                </div>
                                <div className="clear"></div>
                            </div>
                        </div>
                    </div>
                    <div className="height-30"></div>
                </div>
                {this.state.pay && this.state.payType == 10 && (
                    <>
                        <div className="mask"></div>
                        <div className="modal">
                            <div className="pay-modal">
                                <div className="captain">
                                    <a href="javascript:;" className="close" onClick={() => this.cancel()}>
                                        <span className="clips close-ico"></span>
                                    </a>
                                    <h3>
                                        微信支付
                                    </h3>
                                </div>
                                <div className="modal-body">
                                    <p>
                                        支付金额
                                        <span className="text-red">
											￥{this.state.payInfo.disPrice}
										</span>
                                    </p>
                                    <p className="text-gray">
                                        请在30分钟内完成支付
                                    </p>
                                    <p>
                                        <img src={pcUrl('/order/pay', this.state.qrCodeRequest)}/>
                                    </p>
                                    <p className="text-gray">
                                        微信扫码支付
                                    </p>
                                    <p className="text-blue">
                                        <a href="javascript:;" onClick={() => this.payed()}>
                                            我已支付
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {this.state.pay && this.state.payType == 20 && (
                    <>
                        <div className="mask"></div>
                        <div className="modal">
                            <div className="pay-modal">
                                <div className="captain">
                                    <a href="javascript:;" className="close" onClick={() => this.cancel()}>
                                        <span className="clips close-ico"></span>
                                    </a>
                                    <h3>
                                        支付宝支付
                                    </h3>
                                </div>
                                <div className="modal-body">
                                    <p>
                                        支付金额
                                        <span className="text-red">
											￥{this.state.payInfo.disPrice}
										</span>
                                    </p>
                                    <p className="text-gray">
                                        请在30分钟内完成支付
                                    </p>
                                    <p>
                                        <img src={pcUrl('/order/pay', this.state.qrCodeRequest)}/>
                                    </p>
                                    <p className="text-gray">
                                        支付宝扫码支付
                                    </p>
                                    <p className="text-blue">
                                        <a href="javascript:;" onClick={() => this.payed()}>
                                            我已支付
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {this.state.showAddress && (
                    <>
                        <div className="mask"></div>
                        <div className="modal">
                            <div className="address-modal">
                                <div className="captain">
                                    <a href="javascript:;" className="close" onClick={() => this.cancelAddress()}>
                                        <span className="clips close-ico"></span>
                                    </a>
                                    {/*<h4> 请填写收件地址</h4>*/}
                                </div>
                                <div className="modal-body">
                                    <div className="form">
                                        <div className="form-captain">
                                            <h3>
                                                请填写收件地址
                                                <span className="small">（用于接收通用技术材料包）</span>
                                            </h3>
                                        </div>
                                        <div className="form-li">
                                            <span className="label">收件人：</span>
                                            <input ref={e => this.addressNameRef = e} name="name"
                                                   value={this.state.addressInfo.name}
                                                   onChange={e => this.bindModel(e, 'addressInfo').then(() => this.checkFormValid('address'))}
                                                   className="input-text" placeholder="请输入"/>
                                        </div>
                                        <div className="row gutter-1">
                                            <div className="col col-6">
                                                <div className="form-li">
                                                    <span className="label">电话：</span>
                                                    <input ref={e => this.addressMobileRef = e} name="mobile"
                                                           value={this.state.addressInfo.mobile}
                                                           onChange={e => this.bindModel(e, 'addressInfo').then(() => this.checkFormValid('address'))}
                                                           className="input-text" placeholder="请输入"/>
                                                </div>
                                            </div>
                                            <div className="col col-6">
                                                <div className="form-li">
                                                    <span className="label">邮编：</span>
                                                    <input ref={e => this.addressPostCodeRef = e} name="postCode"
                                                           value={this.state.addressInfo.postCode}
                                                           onChange={e => this.bindModel(e, 'addressInfo').then(() => this.checkFormValid('address'))}
                                                           className="input-text" placeholder="请输入"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-li">
                                            <span className="label">所在省市：</span>
                                            <div className="form-value">
                                                <div className="row gutter-2">
                                                    <div className="col col-4">
                                                        <select ref={e => this.addressProvinceRef = e} name="province"
                                                                value={this.state.addressInfo.province} onChange={e => {
                                                            let code = e.target.value;
                                                            this.provinceChange(code);
                                                        }} className="input-text">
                                                            {Object.keys(this.state.provinceList).map((code) => (
                                                                <option
                                                                    value={code}>{this.state.provinceList[code]}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col col-4">
                                                        <select ref={e => this.addressCityRef = e} name="city"
                                                                value={this.state.addressInfo.city} onChange={e => {
                                                            let code = e.target.value;
                                                            this.cityChange(code);
                                                        }} className="input-text">
                                                            {Object.keys(this.state.cityList).map((code) => (
                                                                <option
                                                                    value={code}>{this.state.cityList[code]}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col col-4">
                                                        <select ref={e => this.addressAreaRef = e} name="area"
                                                                value={this.state.addressInfo.area} onChange={e => {
                                                            let code = e.target.value;
                                                            this.areaChange(code);
                                                        }} className="input-text">
                                                            {Object.keys(this.state.areaList).map((code) => (
                                                                <option
                                                                    value={code}>{this.state.areaList[code]}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-li">
                                            <span className="label">详细地址：</span>
                                            <input ref={e => this.addressRef = e} name="address"
                                                   value={this.state.addressInfo.address}
                                                   onChange={e => this.bindModel(e, 'addressInfo').then(() => this.checkFormValid('address'))}
                                                   className="input-text" placeholder="请输入"/>
                                        </div>
                                        <div className="form-li just-end">
                                            <button
                                                className={['button', this.state.formValid.address ? 'button-blue' : 'button-gray'].join(' ')}
                                                onClick={() => this.submitAddress()}>保存更改
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }
}


